import * as appSagas from '@/app/app-sagas';
import * as dashboardSagas from '@/dashboard/dashboard-sagas';
import * as dataSagas from '@/data/data-sagas';
import * as listSagas from '@/list/list-sagas';
import {
  initiateCognitoAuthSetupWatcher,
  onLoginSuccessWatcher,
  setCurrentCityEverywhereWatcher,
  userSignoutWatcher,
  userSwitchedCityWatcher,
} from '@/user/user-sagas';
import { all } from 'redux-saga/effects';

const allSagaWatchers = [
  ...Object.values(appSagas),
  userSignoutWatcher,
  initiateCognitoAuthSetupWatcher,
  userSwitchedCityWatcher,
  setCurrentCityEverywhereWatcher,
  onLoginSuccessWatcher,
  ...Object.values(listSagas),
  ...Object.values(dataSagas),
  ...Object.values(dashboardSagas),
].map((watcher) => watcher());

export function* rootSaga() {
  yield all(allSagaWatchers);
}
